import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-115d3c90"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "ion-text-center",
  style: {"font-size":"small"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_SidebarMenu = _resolveComponent("SidebarMenu")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_tabs = _resolveComponent("ion-tabs")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_fab = _resolveComponent("ion-fab")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: false }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_menu_button, { color: "primary" })
                ]),
                _: 1
              }, 512), [
                [_vShow, true]
              ]),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$route.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    fill: "clear",
                    onClick: $setup.goHome,
                    "aria-label": "Ir al inicio"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: $setup.homeOutline }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: false,
        class: "main-content"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_tabs, null, {
            default: _withCtx(() => [
              ($setup.userAuth().can('view sidebar'))
                ? (_openBlock(), _createBlock(_component_SidebarMenu, { key: 0 }))
                : _createCommentVNode("", true),
              (_openBlock(), _createBlock(_component_ion_router_outlet, {
                id: "main-content",
                key: $setup.routerKey
              })),
              ($setup.currentUserStore().$state.user)
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                    _createTextVNode(" Hola " + _toDisplayString($setup.currentUserStore().$state.user?.name?.split(' ')[0] || $setup.currentUserStore().$state.user?.name || 'Usuario') + " ", 1),
                    _createVNode(_component_ion_icon, {
                      size: "small",
                      icon: $setup.logOutOutline,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.userAuth().logout())),
                      style: {"margin-left":"0.4rem"}
                    }, null, 8, ["icon"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          ($setup.unreadCount > 0)
            ? (_openBlock(), _createBlock(_component_ion_fab, {
                key: 0,
                vertical: "bottom",
                horizontal: "end",
                slot: "fixed",
                class: _normalizeClass(['messages-fab', $setup.getVibrateClass()])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_fab_button, {
                    color: "primary",
                    onClick: $setup.goToMessages
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: $setup.mailOutline }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_ion_badge, {
                    color: "danger",
                    class: "message-badge"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.unreadCount > 99 ? '99+' : $setup.unreadCount), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          ($setup.openIncidenciasCount > 0)
            ? (_openBlock(), _createBlock(_component_ion_fab, {
                key: 1,
                vertical: "bottom",
                horizontal: "end",
                slot: "fixed",
                class: "incidencias-fab",
                style: _normalizeStyle({ right: $setup.unreadCount > 0 ? '90px' : '16px' })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_fab_button, {
                    color: "danger",
                    onClick: $setup.goToIncidencias
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: $setup.warningOutline }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_ion_badge, {
                    color: "danger",
                    class: "incidencia-badge"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.openIncidenciasCount > 99 ? '99+' : $setup.openIncidenciasCount), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["style"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}